import { format, parseISO } from "date-fns"
import { MRT_Cell } from "material-react-table"
import { ContractDto } from "@custom-types/contract"

export const getMaterialTableColumns = () => [
  {
    accessorKey: "key",
    header: "Name",
    size: 400,
  },
  {
    accessorKey: "organisation_key",
    header: "Organisation",
    size: 200,
  },
  {
    accessorKey: "division_key",
    header: "Division",
    size: 200,
  },
  {
    accessorKey: "end_date",
    header: "End Date",
    type: "date",
    size: 200,
    Cell: ({ cell }: { cell: MRT_Cell<ContractDto> }) =>
      parseISO(cell.getValue() as string)
        ? format(parseISO(cell.getValue() as string), "RRRR-LL-dd")
        : "",
  },
  {
    accessorKey: "salesforce_contact",
    header: "Business Line Contact",
    size: 250,
  },
]
